import { ChangeDetectionStrategy, Component, Input } from '@angular/core';


@Component({
    selector: 'legal-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LegalPrivacyPolicyComponent {

	//** Input decorator */
	@Input() content: string;
}
